import axios from "axios";
import { getToken, removeToken } from "./auth";
import { getLocaleFromStorage } from "../contexts/IntlContext";
import {
  clearEstablishmentBlocked,
  isEstablishmentBlockedError,
  isGatedPanelPath,
  setEstablishmentBlocked,
} from "./establishmentBlockedStore";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use(async (config) => {
  const token = getToken();

  if (token) {
    // eslint-disable-next-line no-param-reassign
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers["locale"] = getLocaleFromStorage();
  return config;
});

api.interceptors.response.use(
  (response) => {
    // Uma resposta OK numa dessas rotas significa que o bloqueio de painel (se
    // algum request anterior tiver disparado o aviso global) não se aplica mais
    // — ex.: assinatura foi reativada no meio da sessão. Só limpa com base
    // nessas rotas específicas: /cameras e /users continuam acessíveis mesmo
    // com o painel bloqueado, então um 200 nelas não prova nada sobre o bloqueio.
    if (isGatedPanelPath(response.config?.url)) {
      clearEstablishmentBlocked();
    }
    return response;
  },
  (error) => {
    // Any 401 on an authenticated call means the session is no longer valid
    // (token expired/invalid, user deactivated/deleted or role changed) → force logout.
    // Public auth flows (signin, forgot/reset password, register accept) are excluded
    // so invalid credentials keep showing their own error instead of redirecting.
    if (error?.response?.status === 401) {
      const isPublicAuthFlow = error.config?.url?.includes("app/auth/");
      if (getToken() && !isPublicAuthFlow) {
        removeToken();
      }
    }

    // Aviso global e persistente (banner no Layout) pro bloqueio de painel por
    // atraso na assinatura recorrente do clube — cobre as ~27 telas que batem
    // nas rotas afetadas sem precisar de tratamento individual em cada uma.
    if (isEstablishmentBlockedError(error)) {
      setEstablishmentBlocked();
    }

    return Promise.reject(error);
  }
);

export default api;
